import { z } from 'zod';
const uuid = z.string().uuid();
const dateTime = z.string().datetime({ offset: true });
export const canteenConversationContextSchema = z.object({
    product: z.literal('canteen'),
    kind: z.enum(['reservation', 'issuance', 'settlement', 'case']),
    referenceId: uuid,
    displayLabel: z.string().min(1).max(160).nullable().default(null),
});
/** Sender chooses a policy, not an arbitrary list of accounts. IAM resolves it. */
export const communicationAudienceSelectorSchema = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('direct_person'), personId: uuid }),
    z.object({ kind: z.literal('role'), roleCode: z.string().min(1).max(100) }),
    z.object({ kind: z.literal('group'), groupId: uuid }),
    z.object({ kind: z.literal('canteen_context_participants') }),
    z.object({
        kind: z.literal('team_queue'),
        queueCode: z.string().min(1).max(100),
    }),
]);
export const attachmentReferenceSchema = z.object({
    documentId: uuid,
    versionId: uuid,
    filename: z.string().min(1).max(255),
    sha256: z.string().regex(/^sha256:[a-f0-9]{64}$/),
});
export const sendMessageCommandSchema = z.object({
    contractVersion: z.literal('v1'),
    messageId: uuid,
    idempotencyKey: z.string().min(16).max(200),
    conversationId: uuid.nullable().default(null),
    replyToMessageId: uuid.nullable().default(null),
    subject: z.string().min(1).max(160),
    body: z.string().min(1).max(20_000),
    audience: z.array(communicationAudienceSelectorSchema).min(1).max(20),
    context: canteenConversationContextSchema.nullable().default(null),
    attachments: z.array(attachmentReferenceSchema).max(20).default([]),
    sendAsQueue: z.string().min(1).max(100).nullable().default(null),
});
export const audiencePreviewSchema = z.object({
    total: z.number().int().nonnegative(),
    deduplicated: z.number().int().nonnegative(),
    excluded: z.number().int().nonnegative(),
    categories: z.array(z.object({ key: z.string(), count: z.number().int() })),
    snapshotHash: z.string().regex(/^sha256:[a-f0-9]{64}$/),
    expiresAt: dateTime,
});
export const communicationMessageStatusSchema = z.enum([
    'queued',
    'delivered',
    'read',
    'archived',
    'failed',
]);
export const communicationMessageSchema = z.object({
    id: uuid,
    conversationId: uuid,
    subject: z.string(),
    body: z.string(),
    senderId: uuid,
    sentAt: dateTime,
    context: canteenConversationContextSchema.nullable(),
    status: communicationMessageStatusSchema,
});
export const communicationStatusEventSchema = z.object({
    eventId: uuid,
    schemaVersion: z.literal(1),
    eventType: z.literal('communication.message.status-updated.v1'),
    institutionId: uuid,
    conversationId: uuid,
    messageId: uuid,
    recipientId: uuid,
    status: communicationMessageStatusSchema,
    occurredAt: dateTime,
    recordedAt: dateTime,
    correlationId: z.string().min(1).max(100),
});
